/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_SubInputs */

const en_mk_hero_sub = /** @type {(inputs: Mk_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan projects, talk with your team, and assign work to AI agents. Keep the conversation, context, and approvals together in KerjaBareng.`)
};

const id_mk_hero_sub = /** @type {(inputs: Mk_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencanakan proyek, diskusikan dengan tim, dan tugaskan agen AI. Percakapan, konteks, dan persetujuan tetap terhubung di KerjaBareng.`)
};

/**
* | output |
* | --- |
* | "Plan projects, talk with your team, and assign work to AI agents. Keep the conversation, context, and approvals together in KerjaBareng." |
*
* @param {Mk_Hero_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_sub = /** @type {((inputs?: Mk_Hero_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_sub(inputs)
	return en_mk_hero_sub(inputs)
});